import MenuDesktopView from "./desktop/Menu.desktop.view";
import MenuMobileView from "./mobile/Menu.mobile.view";
import { useIsDesktopDevice } from "../../tools/hooks/useIsDesktopDevice.ts";
import { useIsMobileDevice } from "../../tools/hooks/useIsMobileDevice.ts";
import type MenuProperties from "./Menu.properties.ts";

export default function MenuView(props: MenuProperties) {
  const isDesktop = useIsDesktopDevice();
  const isMobile = useIsMobileDevice();

  return (
    <>
      {isMobile && <MenuMobileView />}
      {isDesktop && <MenuDesktopView {...props} />}
    </>
  );
}
